var map = {
	"./2checkout.png": "117e",
	"./culqi-lg.png": "6d5c",
	"./culqi.png": "991b",
	"./deposito-bancario.png": "c54f",
	"./izipay-lg.png": "03d5",
	"./izipay.png": "e605",
	"./kushki.png": "6e39",
	"./mercado-pago-lg.png": "c712",
	"./mercado-pago.png": "64c6",
	"./niubiz-lg.png": "7515",
	"./niubiz.png": "7965",
	"./pago-efectivo-lg.png": "8608",
	"./pago-efectivo.png": "c8ff",
	"./payme.png": "b584",
	"./paypal.png": "a90b",
	"./payu.png": "67a4",
	"./plin-lg.png": "2ce7",
	"./plin.png": "2103",
	"./yape-lg.png": "99d3",
	"./yape.png": "3153"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f70";